import { axios, Response } from '../index'

type Body = {
  membersIds: string[]
}

const deleteAssignedTaskMembers = (
  taskId: string,
  body: Body
): Response<null> => {
  return axios.delete(`/v1/tasks/${taskId}/members`, { data: body })
}

export default deleteAssignedTaskMembers
